import React, { FC, useEffect, useState } from "react";

import { getSpApi } from "@/shared/apis/apiRoot";
import { useMediaDisplayer } from "@/shared/hooks";

import { StyledConversationThumbnail, StyledConversationThumbnailDescription } from "./styled";

type ConversationThumbnailProps = {
    type: string;
    url: string;
    alt: string;
};

const ConversationThumbnail: FC<ConversationThumbnailProps> = ({ url, alt, type }) => {
    const [imgSrc, setImgSrc] = useState(null);
    const { displayFullMode } = useMediaDisplayer();

    useEffect(() => {
        getSpApi()
            .get<Blob>(url, { responseType: "blob" })
            .then((res) => {
                const reader = new window.FileReader();
                reader.readAsDataURL(res.data);
                reader.onload = () => {
                    setImgSrc(reader.result);
                };
            });
    }, []);

    const openDocumentDisplay = () => displayFullMode({ title: alt, type, url: url.replace("?thumbnail=true", "") });

    return imgSrc !== null ? (
        <div role="button" onClick={openDocumentDisplay} aria-hidden>
            <StyledConversationThumbnail
                aria-hidden
                $pdfThumbnail={type === "application/pdf"}
                src={imgSrc}
                alt={alt}
            />
            {type === "application/pdf" && (
                <StyledConversationThumbnailDescription>{alt}</StyledConversationThumbnailDescription>
            )}
        </div>
    ) : null;
};

export default ConversationThumbnail;
